
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf/[partNumber]",
      function () {
        return require("private-next-pages/pdf/[partNumber].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf/[partNumber]"])
      });
    }
  